"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var _Icon = require("../../Icon");
var _IconButton = _interopRequireDefault(require("../../IconButton"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DateButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var onOpen = _ref.openPicker,
    disabled = _ref.disabled,
    tooltip = _ref.tooltip;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
    tooltip: tooltip,
    icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.EventIcon, {}),
    disabled: disabled,
    ref: ref,
    onClick: onOpen
  });
});
var _default = exports["default"] = DateButton;